var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TransferSpaceOptionService } from './transfer-space-option-service.interface';
import { TransferSpaceService } from './transfer-space-service.interface';
import { Logger } from '@patsnap/tahiti-core/common/logger';
import { AbstractSpaceActionService } from '@/services/space-action-service';
import { I18nService } from '@/services/i18n-service';
import { ConfirmTransferToPublicService } from './confirm-transfer-to-public-service.interface';
import { SpaceLabelService } from '@/domains/spaces/services/space-label-service.interface';
let TransferSpaceContribution = class TransferSpaceContribution extends AbstractSpaceActionService {
    constructor(_transferSpaceOptionService, _transferSpaceService, _logger, _i18nService, _confirmShareToPublicService, _spaceLabelService) {
        super();
        this._transferSpaceOptionService = _transferSpaceOptionService;
        this._transferSpaceService = _transferSpaceService;
        this._logger = _logger;
        this._i18nService = _i18nService;
        this._confirmShareToPublicService = _confirmShareToPublicService;
        this._spaceLabelService = _spaceLabelService;
        this._transferSpaceOptionService.onReceived(this._onReceived.bind(this));
        this._transferSpaceOptionService.onAborted(this._onAborted.bind(this));
    }
    async _onReceived(data, next) {
        if (data.transferCompanySpace) {
            const bool = await this._confirmShareToPublicService.request({ title: '' });
            if (!bool) {
                return;
            }
        }
        await this._transferSpaceService.transferSpace([
            this.currentSpaceService.getCurrentSpace().spaceId,
        ], data);
        this._spaceLabelService.resetSpaceLabel();
        next();
    }
    async _onAborted(error) {
        this._logger.info('Transfer Space abort by user', error);
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'transfer-space',
        }, {
            execute: () => {
                return this._transferSpaceOptionService.request({ title: 'Transfer Space' });
            },
        });
        commands.registerCommand({
            id: 'transfer-space:cancel',
        }, {
            execute: () => {
                return this._transferSpaceOptionService.abort();
            },
        });
    }
    registerSpaceActions(spaceActionRegistry) {
        spaceActionRegistry.registerSpaceAction({
            order: 97,
            commandId: 'transfer-space',
            label: this._i18nService.t('workspace.transfer.tip'),
            iconClass: 'SolidTransferWorkspace',
            isEnabled: (space) => {
                return !space.isShared && !space.isPublic;
            },
            isVisible: (space) => {
                return !space.isShared && !space.isPublic;
            },
        });
    }
};
TransferSpaceContribution = __decorate([
    injectable(),
    __param(0, inject(TransferSpaceOptionService)),
    __param(1, inject(TransferSpaceService)),
    __param(2, inject(Logger)),
    __param(3, inject(I18nService)),
    __param(4, inject(ConfirmTransferToPublicService)),
    __param(5, inject(SpaceLabelService)),
    __metadata("design:paramtypes", [typeof (_a = typeof TransferSpaceOptionService !== "undefined" && TransferSpaceOptionService) === "function" ? _a : Object, typeof (_b = typeof TransferSpaceService !== "undefined" && TransferSpaceService) === "function" ? _b : Object, typeof (_c = typeof Logger !== "undefined" && Logger) === "function" ? _c : Object, typeof (_d = typeof I18nService !== "undefined" && I18nService) === "function" ? _d : Object, typeof (_e = typeof ConfirmTransferToPublicService !== "undefined" && ConfirmTransferToPublicService) === "function" ? _e : Object, typeof (_f = typeof SpaceLabelService !== "undefined" && SpaceLabelService) === "function" ? _f : Object])
], TransferSpaceContribution);
export { TransferSpaceContribution };
